import {
  Box,
  Button,
  Cell,
  Divider,
  Heading,
  Layout,
  ModalMobileLayout,
  Text,
} from '@wix/design-system';
import * as React from 'react';
import { SelectorCheckBoxMobile } from './selector-checkbox-mobile';
import { config } from '../../../config';
import { composer } from '../../../component-decorators/composer';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import type { SubCategory } from '@wix/ambassador-marketplace/types';
import type { MarketplaceStore } from '../../../component-decorators/with-marketplace-store';

export interface SubCategoriesSelectorModalMobileProps
  extends Partial<WithTranslationProps> {
  marketplaceStore?: MarketplaceStore;
  subCategories: SubCategory[];
  checkedSubCategories: SubCategory[];
  categoryName: string;
  name: string;
  setCheckedSubCategories(subCategories: SubCategory[]): void;
  closeModal(): void;
}

export const SubCategoriesSelectorModalMobile = composer()
  .withMarketplaceStore()
  .withTranslation()
  .compose(
    ({
      subCategories,
      categoryName,
      closeModal,
      setCheckedSubCategories,
      checkedSubCategories,
      marketplaceStore,
      name,
      t,
    }: SubCategoriesSelectorModalMobileProps) => (
      <ModalMobileLayout
        title={
          <>
            <Heading appearance="H2">{name}</Heading>
            <Text weight="normal">{`${t(
              'category-header-mobile.filter-subcategory.title',
            )}:`}</Text>
          </>
        }
        fullscreen={true}
        content={
          <SubCategoriesSelectorModalMobileContent
            subCategories={subCategories}
            categoryName={categoryName}
            closeModal={closeModal}
            setCheckedSubCategories={setCheckedSubCategories}
            checkedSubCategories={checkedSubCategories}
            name={name}
          />
        }
        footer={
          <SubCategoriesSelectorModalMobileFooter
            onChoose={() => {
              config.goto({
                path: marketplaceStore.route.path,
                slug: marketplaceStore.route.slug,
                subCategories: checkedSubCategories.map(
                  (checked) => checked.slug,
                ),
              });
              setCheckedSubCategories(checkedSubCategories);
              closeModal();
            }}
            onCancel={() => {
              setCheckedSubCategories([]);
              closeModal();
            }}
          />
        }
        onCloseButtonClick={() => {
          setCheckedSubCategories([]);
          closeModal();
        }}
        stickyTitle={true}
        stickyFooter={true}
      />
    ),
  );

const SubCategoriesSelectorModalMobileFooter = composer()
  .withTranslation()
  .compose(({ onChoose, onCancel, t }) => (
    <Box align="right">
      <Box marginRight="12px">
        <Button priority="secondary" onClick={onCancel}>
          {t('category-header-mobile.filter-subcategory.cancel')}
        </Button>
      </Box>
      <Button onClick={onChoose}>
        {t('category-header-mobile.filter-subcategory.filter')}
      </Button>
    </Box>
  ));

class SubCategoriesSelectorModalMobileContent extends React.Component<
  SubCategoriesSelectorModalMobileProps,
  any
> {
  render() {
    const { subCategories, checkedSubCategories, setCheckedSubCategories } =
      this.props;
    return (
      <Layout gap="18px">
        <SelectorCheckBoxMobile
          subCategory={null}
          subCategoriesCount={subCategories.length}
          setCheckedSubCategories={setCheckedSubCategories}
          checkedSubCategories={checkedSubCategories}
        />
        <Cell>
          <Divider />
        </Cell>
        {subCategories.map((subCategory) => (
          <SelectorCheckBoxMobile
            subCategory={subCategory}
            subCategoriesCount={subCategories.length}
            setCheckedSubCategories={setCheckedSubCategories}
            checkedSubCategories={checkedSubCategories}
          />
        ))}
      </Layout>
    );
  }
}
